import {
  getRequestEditDescriptionModalInitialValues,
  RequestEditDescriptionModal,
} from '../../../RequestEditDescriptionModal'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'

export function useRequestProfileHeaderDescription({
  requestDescriptionHtml,
  onAfterSubmit,
}) {
  const { handleCloseModal, handleUpdateEntity, requestData, setModal } =
    useRequestProfileContext()

  function handleEditDescriptionSubmit({ payload }) {
    return handleUpdateEntity(payload).then(() => {
      onAfterSubmit?.()
      handleCloseModal()
    })
  }

  function handleOpenEditDescriptionModal() {
    setModal(
      <RequestEditDescriptionModal
        initialValues={getRequestEditDescriptionModalInitialValues(
          requestDescriptionHtml
        )}
        onClose={handleCloseModal}
        onSubmit={handleEditDescriptionSubmit}
      />
    )
  }

  return {
    canEditDescription: Boolean(requestData?.permissions?.can_edit_content),
    onClickEditDescription: handleOpenEditDescriptionModal,
  }
}
